export interface WidthChangeEvent {
    width: number;
    colIndex: number;
}
